import { wsService } from "./wsService";

const section = "geocoding";

function geocode(params) {
  return wsService.make_post_request(section + "/geocode", params);
}

export const geoService = {
  section,
  geocode,
};
